import { Link } from "react-router-dom";
import Button from "../../../../components/Button";
import IconButton from "../../../../components/IconButton";
import { TimerInfo } from "../../../../components/TimerTopLeftScreen";
import { IconCheck, IconCheckCircle } from "../../../../icons";
import { BodyAuthComponents } from "../../components/BodyAuth";

export function SuccessReset() {
  return (
    <>
      <TimerInfo />
      <div className="flex flex-col items-center w-3/5 sm:w-4/5">
        <IconButton icon={IconCheckCircle} className="icon-createdCorp box-icon-checked" />
        <div className="flex justify-center items-center"></div>
        <div className="box-pulse-created flex justify-center items-center"></div>
        <h1 className="text-5xl font-semibold">Sucesso!</h1>
        <p className="text-1.6rem mt-5 text-textPrimary text-center">Sua nova senha foi definida com sucesso. </p>
      </div>
      <div className="flex flex-col w-full gap-6 px-4">
        <div className="w-full flex justify-center">
          <Link to="/" className="w-3/5 sm:w-4/5 h-full">
            <Button className="w-full text-textPrimary bg-primary hover:bg-gray-100 rounded-xl">Acessar Integra</Button>
          </Link>
        </div>
      </div>
    </>
  );
}
